import React from 'react';
import { Divider, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { EqualisationSettingsFormValues } from './FormWrapper';
import EqualisationInterestFeeTemplateFields from './EqualisationInterestFeeTemplateFields';
import { Column, Row } from 'further-ui/components/Layout';
import Button from 'components/Button';
import {
  PreferredReturnAccrualMethod,
  PreferredReturnBasis,
  PreferredReturnCompoundingPeriod,
} from 'further-types/lp/carry-settings';

const EqualisationInterestFeeTemplates: React.FC = () => {
  const { control, getValues } =
    useFormContext<EqualisationSettingsFormValues>();

  const equalisationInterestFeeTemplates = getValues(
    'equalisationInterestFeeTemplates',
  );

  const templateIdsInUse =
    equalisationInterestFeeTemplates
      ?.filter((template) => template.isInUse)
      ?.map((template) => template._id) ?? [];

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'equalisationInterestFeeTemplates',
  });

  const handleRemoveTemplate = (index: number) => {
    if (fields.length < 2) return;

    remove(index);
  };

  return (
    <>
      {fields.map((field, index) => (
        <Column fullWidth spacing="lg" key={field.id}>
          <Divider />
          <Row centered fullWidth justify="space-between" spacing="sm">
            <Typography variant="h5" width="100%">
              Equalisation interest fee template {index + 1}
            </Typography>
            <Row fullWidth justify="flex-end">
              <Button
                variant="text"
                color="error"
                onClick={() => handleRemoveTemplate(index)}
                disabled={
                  fields.length < 2 ||
                  (!!field._id && templateIdsInUse.includes(field._id))
                }
                tooltip={
                  !!field._id && templateIdsInUse.includes(field._id)
                    ? 'This template is in use and cannot be removed'
                    : undefined
                }
              >
                Remove equalisation interest fee template
              </Button>
            </Row>
          </Row>
          <EqualisationInterestFeeTemplateFields index={index} />
        </Column>
      ))}
      <Row fullWidth justify="flex-end">
        <Button
          variant="outlined"
          color="primary"
          size="large"
          type="button"
          onClick={() =>
            append({
              name: '',
              equalisationInterestRate: 0,
              equalisationInterestAccrualMethod:
                PreferredReturnAccrualMethod.Simple,
              equalisationInterestCompoundingPeriod:
                PreferredReturnCompoundingPeriod.Daily,
              equalisationInterestBasis: PreferredReturnBasis.Drawn,
              isDefault: false,
              isInUse: false,
            })
          }
        >
          Add new equalisation interest fee template
        </Button>
      </Row>
    </>
  );
};

export default EqualisationInterestFeeTemplates;
